import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {Router} from '@angular/router';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {JwtService} from "../../../@core/auth/jwt.service";
import {HttpErrorResponse} from "@angular/common/http";


@Injectable()


export class AuthUserService {
  public user: BehaviorSubject<any>;
  public user$: Observable<any>;
  public profileRequest: Subject<void>;

  constructor(
    @Inject(LOCAL_STORAGE)
    private storage: StorageService,
    private router: Router,
    private jwtService: JwtService,
  ) {
    this.user = new BehaviorSubject<any>(this.storage.get('user'));
    this.user$ = this.user.asObservable();

    this.profileRequest = new Subject();
    this.profileRequest.pipe(
      switchMap(() => this.jwtService.getUserProfile().pipe(
          catchError((error: HttpErrorResponse) => this.onProfileRequestError(error))
        )
      ))
      .subscribe((user: any) => {
        const url = router.routerState.snapshot.url;
        // console.log(user);
        this.setUser(user);
        if (url === '/login') {
          this.router.navigate(['/']);
        }
      });

    if (this.checkAuthorizedStatus()) {
      this.requestProfile();
    }
  }

  public requestProfile(): void {
    this.profileRequest.next();
  }

  public async logout(): Promise<void> {
    this.user.next(null);
    this.storage.remove('user');
    await this.router.navigate(['/login']);
  }

  public setUser(user: any) {
    this.user.next(user);
    this.storage.set('user', user);
  }

  public checkAuthorizedStatus(): boolean {
    return !!this.user.getValue();
  }

  private onProfileRequestError(e: HttpErrorResponse): Observable<null> {
    return of(null);
  }
}

